import React from "react";

const ModalRetiradaLoja = () => {
    return (
        <div
            className="ModalModalidades"
            style={{ backgroundColor: "#E6DDCE" }}
        >
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-11">
                        <h2 className="text-center mb-4">
                            <strong>Retirada na Loja</strong>
                        </h2>

                        <div className="mb-4">
                            <p>
                                Ao escolher a opção <strong>Retirada na Loja</strong>,
                                seu pedido não será enviado por transportadora.
                            </p>

                            <p>
                                Após a confirmação do pagamento, seu pedido será
                                preparado por nossa equipe.
                            </p>

                            <p>
                                Assim que estiver disponível para retirada, você
                                receberá uma confirmação por e-mail com todas as
                                orientações necessárias.
                            </p>

                            <p>
                                <strong>
                                    Aguarde a confirmação por e-mail antes de
                                    comparecer à loja.
                                </strong>
                            </p>

                            <hr />

                            <h5>
                                <strong>Local de retirada</strong>
                            </h5>

                            <p>
                                Rua Halfeld, nº 1156<br />
                                Centro - Juiz de Fora/MG<br />
                                CEP: 36016-000
                            </p>

                            <p>
                                <strong>Horário de retirada:</strong><br />
                                Segunda a Sexta-feira<br />
                                08h às 18h
                            </p>

                            <hr />

                            <p
                                className="mb-0"
                                style={{
                                    fontSize: "14px",
                                    fontStyle: "italic",
                                }}
                            >
                                * Seu pedido ficará reservado para retirada por
                                até <strong>7 dias úteis</strong> após a
                                confirmação de disponibilidade. Após esse
                                período, poderá ser necessária a contratação de
                                envio para entrega do pedido.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalRetiradaLoja;